import { AppConfig } from '../types';

import seepopIcon from '../assets/apps_imgs/seepop_icon.png';
import seepop01Main from '../assets/apps_imgs/seepop_01_main.webp';
import seepop02Cbti from '../assets/apps_imgs/seepop_02_cbti.webp';
import seepop03Maps from '../assets/apps_imgs/seepop_03_maps.webp';
import seepop04Calendar from '../assets/apps_imgs/seepop_04_calendar.webp';

import hedgIcon from '../assets/apps_imgs/hedg_icon.png';
import hedg01Home from '../assets/apps_imgs/hedg_01_home.webp';
import hedg02Wallet from '../assets/apps_imgs/hedg_02_wallet.webp';
import hedg03Analytics from '../assets/apps_imgs/hedg_03_analytics.webp';
import hedg04Ai from '../assets/apps_imgs/hedg_04_ai.webp';
import hedg05Import from '../assets/apps_imgs/hedg_05_import.webp';
import hedg06Start from '../assets/apps_imgs/hedg_06_start.webp';

export const APPS_DATA: AppConfig[] = [
  {
    id: 'app-seepop',
    slug: 'seepop',
    name: 'Seepop',
    tagline: {
      ko: '내 취향에 꼭 맞는 팝업스토어, 이제 Seepop에서 가장 먼저 찾아보세요.',
      en: 'Find the pop-up stores you’ll love, before anyone else.',
    },
    description: {
      ko: '요즘 팝업스토어, 너무 많아서 어디부터 가야 할지 고민되시죠? 겨우 마음에 드는 곳을 찾았는데 이미 끝나버린 적도 한 번쯤 있으실 거예요. Seepop은 전국의 팝업스토어 소식을 한곳에 모아, 내 취향에 맞는 팝업을 놓치지 않고 쉽게 찾을 수 있도록 도와드려요.',
      en: 'So many pop-up stores, so little time — and the one you wanted has often already closed. Seepop gathers pop-ups from across Korea in one place so you can easily find the ones that match your taste, without missing out.',
    },
    iconUrl: seepopIcon,
    accentColor: '#3CAC81',
    category: {
      ko: '라이프스타일 & 컬처',
      en: 'Lifestyle & Culture',
    },
    platforms: ['ios', 'android'],
    appStoreUrl: 'https://apps.apple.com/kr/app/seepop/id6504471691?l=ko',
    googlePlayUrl: 'https://play.google.com/store/apps/details?id=com.kapitalletter.project_poppin&hl=ko',
    currentVersion: 'v1.1.2',
    lastUpdated: '2026-10-01',
    supportEmail: 'contact@kapitalletter.com',
    targetAudience: [
      {
        ko: '성수·홍대·더현대처럼 요즘 뜨는 팝업을 놓치고 싶지 않은 분',
        en: 'You never want to miss the latest pop-ups in places like Seongsu, Hongdae, and The Hyundai',
      },
      {
        ko: '팝업이 너무 많아서, 나한테 맞는 곳만 골라 추천받고 싶은 분',
        en: 'There are too many pop-ups and you just want the ones picked for you',
      },
      {
        ko: '이번 주말 어디 갈지, 근처에 어떤 팝업이 열렸는지 한눈에 보고 싶은 분',
        en: 'You want to see what’s open nearby and plan your weekend at a glance',
      },
    ],
    features: [
      {
        id: 'feat-seepop-cbti',
        title: {
          ko: '나에게 딱 맞는 팝업 추천',
          en: 'Pop-ups Picked for You',
        },
        description: {
          ko: '간단한 질문 몇 개에 답하면 나의 취향 유형(CBTI)을 알려드리고, 좋아할 만한 팝업을 골라 추천해 드려요.',
          en: 'Answer a few quick questions to discover your taste type (CBTI), and we’ll recommend pop-ups you’re likely to love.',
        },
        badge: {
          ko: '취향 추천',
          en: 'For You',
        },
      },
      {
        id: 'feat-seepop-map',
        title: {
          ko: '지도로 찾는 내 주변 팝업',
          en: 'Nearby Pop-ups on the Map',
        },
        description: {
          ko: '지금 있는 곳 근처나 자주 가는 동네, 요즘 핫한 지역에 어떤 팝업이 열렸는지 지도에서 바로 확인해 보세요.',
          en: 'See what’s open around you, in your favorite neighborhoods, or in today’s hot spots — right on the map.',
        },
      },
      {
        id: 'feat-seepop-calendar',
        title: {
          ko: '캘린더로 보는 팝업 일정',
          en: 'Pop-up Calendar',
        },
        description: {
          ko: '가고 싶던 팝업이 이미 끝나버리는 일은 이제 그만! 날짜별로 언제 어떤 팝업이 열리는지 한눈에 볼 수 있어요.',
          en: 'No more showing up after it’s over. See which pop-ups are open on any given day.',
        },
      },
      {
        id: 'feat-seepop-status',
        title: {
          ko: '지금 갈 수 있는 팝업만 골라보기',
          en: 'Show Only What’s Open',
        },
        description: {
          ko: '운영 중인 곳, 곧 오픈하는 곳, 곧 끝나는 곳까지 원하는 팝업만 골라서 볼 수 있어요.',
          en: 'Choose to see pop-ups that are open now, opening soon, or closing soon.',
        },
      },
      {
        id: 'feat-seepop-detail',
        title: {
          ko: '찜해두고 친구에게 공유하기',
          en: 'Save & Share with Friends',
        },
        description: {
          ko: '운영 시간, 위치, 사진까지 한 번에 확인하고, 마음에 드는 팝업은 찜해두거나 친구에게 바로 공유해 보세요.',
          en: 'Check hours, location, and photos in one place, then save your favorites or send them to friends.',
        },
      },
    ],
    screenshots: [
      {
        id: 'ss-seepop-1',
        url: seepop01Main,
        caption: { ko: '어디 갈지 고민될 땐 Seepop', en: 'Not sure where to go? Try Seepop' },
        alt: { ko: 'Seepop 메인 화면', en: 'Seepop main screen' },
      },
      {
        id: 'ss-seepop-2',
        url: seepop02Cbti,
        caption: { ko: '내 취향에 맞는 팝업 추천', en: 'Pop-ups matched to your taste' },
        alt: { ko: 'CBTI 취향 분석 화면', en: 'CBTI analysis screen' },
      },
      {
        id: 'ss-seepop-3',
        url: seepop03Maps,
        caption: { ko: '지도로 찾는 내 주변 팝업', en: 'Find pop-ups near you' },
        alt: { ko: 'Seepop 지도 탐색 화면', en: 'Seepop map view' },
      },
      {
        id: 'ss-seepop-4',
        url: seepop04Calendar,
        caption: { ko: '날짜별로 확인하는 팝업 일정', en: 'Check pop-ups by date' },
        alt: { ko: 'Seepop 캘린더 화면', en: 'Seepop calendar view' },
      },
    ],
    faqs: [
      {
        id: 'faq-seepop-cbti',
        category: 'general',
        question: {
          ko: 'CBTI 취향 분석은 언제든 다시 할 수 있나요?',
          en: 'Can I retake the CBTI taste quiz?',
        },
        answer: {
          ko: '네, 마이페이지의 CBTI 메뉴에서 언제든지 테스트를 다시 진행하여 추천 결과를 업데이트하실 수 있습니다.',
          en: 'Yes, you can retake the test at any time in My Page to update your recommendations.',
        },
      },
      {
        id: 'faq-seepop-location',
        category: 'troubleshooting',
        question: {
          ko: '지도에서 현재 위치 주변 팝업이 보이지 않아요.',
          en: 'Nearby pop-ups are not showing on the map.',
        },
        answer: {
          ko: '기기의 위치 권한 설정이 허용되어 있는지 확인해 주세요. [설정 > Seepop > 위치 접근 허용]을 활성화하시면 즉시 내 주변 팝업이 표시됩니다.',
          en: 'Please check if Location Permission is granted in your device settings under [Settings > Seepop > Location].',
        },
      },
      {
        id: 'faq-seepop-report',
        category: 'general',
        question: {
          ko: '새로운 팝업 정보 제보나 일정 수정 요청은 어떻게 하나요?',
          en: 'How do I submit a new pop-up or request schedule updates?',
        },
        answer: {
          ko: '앱 내 제보하기 버튼 또는 공식 지원 이메일(contact@kapitalletter.com)로 행사명과 링크를 보내주시면 운영팀에서 신속히 검토 후 반영합니다.',
          en: 'You can submit tips via the in-app tip button or email us at contact@kapitalletter.com.',
        },
      },
    ],
  },
  {
    id: 'app-hed-g',
    slug: 'hed-g',
    name: '생활의 HED-G',
    tagline: {
      ko: '햇쥐와 함께 쓰는 AI 가계부. 오늘 써도 되는 돈부터 소비 분석까지',
      en: 'An AI budget app with your hedgehog buddy — from what you can spend today to where it all went.',
    },
    description: {
      ko: '생활의 HED-G는 통장 잔액, 다가오는 카드값, 매달 나가는 고정비까지 계산해서 오늘 마음 놓고 써도 되는 금액을 보여 주는 가계부예요. 궁금한 게 생기면 AI 비서 햇쥐에게 물어보면 내 가계부를 바탕으로 답해 주고, 모든 기록과 분석은 외부 서버가 아닌 내 기기 안에서만 처리돼요.',
      en: 'HED-G adds up your bank balances, upcoming card bills, and recurring expenses to show exactly how much you can comfortably spend today. Got a question? Ask Hetzzi, your AI assistant, and get answers based on your own budget — with every record and analysis handled on your device, never on an external server.',
    },
    iconUrl: hedgIcon,
    accentColor: '#3CAC81',
    category: {
      ko: '금융 & 자산 관리',
      en: 'Finance & Asset Management',
    },
    platforms: ['android', 'ios', 'mac', 'windows'],
    // Store links intentionally omitted as the app is currently in preparation
    appStoreUrl: undefined,
    googlePlayUrl: undefined,
    currentVersion: '출시 준비 중',
    lastUpdated: '2026-10-23',
    supportEmail: 'contact@kapitalletter.com',
    targetAudience: [
      {
        ko: '통장 잔액은 있는데 카드값 빠지고 나면 실제로 얼마 남는지 늘 헷갈렸던 분',
        en: 'You have money in the bank but never know what’s really left after card bills',
      },
      {
        ko: '내 카드 내역이나 소비 기록이 외부 서버에 올라가는 게 불안했던 분',
        en: 'You feel uneasy about your card history being uploaded to someone else’s server',
      },
      {
        ko: '가계부를 처음부터 하나하나 쓰기 귀찮아서 자꾸 미뤄왔던 분',
        en: 'You keep putting off budgeting because starting from scratch is a hassle',
      },
    ],
    features: [
      {
        id: 'feat-hedg-available',
        title: {
          ko: '오늘 써도 되는 돈, 한눈에',
          en: 'What You Can Spend Today',
        },
        description: {
          ko: '통장 잔액에서 다가오는 카드값과 고정비를 미리 빼서, 지금 마음 놓고 쓸 수 있는 금액을 첫 화면에서 바로 보여 드려요.',
          en: 'Upcoming card bills and recurring expenses are deducted from your balances ahead of time, so your home screen shows what you can actually spend right now.',
        },
        badge: {
          ko: '사용가능 금액',
          en: 'Spendable Now',
        },
      },
      {
        id: 'feat-hedg-wallet',
        title: {
          ko: '통장과 카드를 지갑처럼',
          en: 'Accounts & Cards Like a Wallet',
        },
        description: {
          ko: '통장·현금·신용카드를 지갑처럼 한곳에 모아 보고, 카드마다 이번 달 결제 예정 금액과 출금일까지 한 번에 확인할 수 있어요.',
          en: 'Keep bank accounts, cash, and credit cards together like a wallet, and see each card’s upcoming bill and payment date at a glance.',
        },
      },
      {
        id: 'feat-hedg-analytics',
        title: {
          ko: '어디에 썼는지 바로 보이는 소비 분석',
          en: 'See Where Your Money Went',
        },
        description: {
          ko: '식비·교통·카페처럼 카테고리별 지출을 차트로 정리해 보여 드려요. 항목을 누르면 어떤 내역이 있었는지 바로 펼쳐 볼 수 있어요.',
          en: 'Spending is broken down by category — food, transport, café, and more — in a clear chart. Tap any category to see the transactions behind it.',
        },
      },
      {
        id: 'feat-hedg-ai',
        title: {
          ko: '궁금하면 햇쥐에게 물어봐',
          en: 'Just Ask Hetzzi',
        },
        description: {
          ko: '“이번 달 소비 현황 요약해 줘”, “배달 30% 줄이면?”처럼 편하게 물어보세요. AI 비서 햇쥐가 내 가계부를 바탕으로 정보를 밖으로 보내지 않고 내 폰 안에서 답해 줘요.',
          en: 'Ask things like “Summarize my spending this month” or “What if I cut delivery by 30%?” Hetzzi answers from your own budget, right on your phone, without sending your data anywhere.',
        },
        badge: {
          ko: '온디바이스 AI',
          en: 'On-Device AI',
        },
      },
      {
        id: 'feat-hedg-import',
        title: {
          ko: '지난 소비도 캡처 한 장으로',
          en: 'Import Past Spending from a Screenshot',
        },
        description: {
          ko: '카드·은행 앱의 이용내역 화면을 캡처해 올리거나, 엑셀·CSV 파일, 결제 문자를 붙여넣기만 하면 지난 소비가 바로 정리돼요. 사진은 기기 안에서만 읽고, 카드·계좌번호는 지운 뒤 보관해요.',
          en: 'Upload a screenshot of your card or bank app, import an Excel/CSV file, or paste a payment text — your past spending is organized instantly. Photos are read only on your device, and card and account numbers are removed.',
        },
        badge: {
          ko: '개인정보 안심',
          en: 'Privacy First',
        },
      },
      {
        id: 'feat-hedg-android-tracker',
        title: {
          ko: '결제 알림으로 자동 기록 (Android)',
          en: 'Auto-Log from Payment Alerts (Android)',
        },
        description: {
          ko: '카드 결제 문자나 앱 알림이 오면 자동으로 알아채서, 버튼 한 번만 누르면 가계부에 바로 기록돼요.',
          en: 'When a card payment text or notification arrives, HED-G picks it up so you can save it with a single tap.',
        },
      },
    ],
    screenshots: [
      {
        id: 'ss-hedg-1',
        url: hedg01Home,
        caption: { ko: '오늘 써도 되는 돈 한눈에', en: 'What you can spend today, at a glance' },
        alt: { ko: '생활의 HED-G 홈 화면 – 사용가능 금액과 이번 달 소비 분석', en: 'HED-G home screen showing spendable amount and monthly spending' },
      },
      {
        id: 'ss-hedg-2',
        url: hedg02Wallet,
        caption: { ko: '통장과 카드를 지갑처럼', en: 'Your accounts and cards, like a wallet' },
        alt: { ko: '생활의 HED-G 내 통장·카드 화면 – 잔액과 카드 결제 예정일', en: 'HED-G wallet screen showing balances and card payment dates' },
      },
      {
        id: 'ss-hedg-3',
        url: hedg03Analytics,
        caption: { ko: '어디에 썼는지 바로 보여요', en: 'See exactly where it went' },
        alt: { ko: '생활의 HED-G 카테고리별 소비 분석 화면', en: 'HED-G spending-by-category analysis screen' },
      },
      {
        id: 'ss-hedg-4',
        url: hedg04Ai,
        caption: { ko: '궁금하면 햇쥐에게 물어봐', en: 'Got a question? Ask Hetzzi' },
        alt: { ko: '생활의 HED-G AI 비서 햇쥐 대화 화면', en: 'HED-G chat screen with AI assistant Hetzzi' },
      },
      {
        id: 'ss-hedg-5',
        url: hedg05Import,
        caption: { ko: '지난 소비도 캡처 한 장으로', en: 'Import past spending with one screenshot' },
        alt: { ko: '생활의 HED-G 지난 소비 가져오기 화면 – 캡처·엑셀·붙여넣기', en: 'HED-G import screen with screenshot, Excel/CSV, and paste options' },
      },
      {
        id: 'ss-hedg-6',
        url: hedg06Start,
        caption: { ko: '햇쥐와 함께 가볍게 시작', en: 'Get started with Hetzzi' },
        alt: { ko: '생활의 HED-G 시작 화면 – 햇쥐 인사', en: 'HED-G onboarding screen with Hetzzi' },
      },
    ],
    faqs: [
      {
        id: 'faq-hedg-privacy',
        category: 'data-privacy',
        question: {
          ko: '내 금융 정보나 결제 내역이 외부 서버로 전송되나요?',
          en: 'Are my financial transactions sent to external servers?',
        },
        answer: {
          ko: '아니요, 전송되지 않아요. 거래 내역과 결제 알림, AI 분석까지 모두 내 기기 안에서만 처리되기 때문에 외부 서버로 보내지는 정보가 없어요.',
          en: 'No. Your records, payment alerts, and AI analysis are all handled on your device, so nothing is sent to an external server.',
        },
      },
      {
        id: 'faq-hedg-store',
        category: 'general',
        question: {
          ko: '앱스토어 및 구글 플레이 출시 일정은 어떻게 되나요?',
          en: 'When will the app be released on App Store and Google Play?',
        },
        answer: {
          ko: '지금은 안드로이드와 데스크톱 버전을 마지막으로 다듬고 있어요. 스토어 출시 준비가 끝나는 대로 이 페이지에서 다운로드 링크를 안내해 드릴게요.',
          en: 'We’re putting the finishing touches on the Android and desktop versions. Download links will appear on this page as soon as the app is released.',
        },
      },
      {
        id: 'faq-hedg-backup',
        category: 'troubleshooting',
        question: {
          ko: '기기를 변경할 때 데이터 이전은 어떻게 하나요?',
          en: 'How do I transfer data when changing devices?',
        },
        answer: {
          ko: '앱의 데이터 내보내기·가져오기 기능을 이용하면 지금까지의 기록을 새 기기로 그대로 옮길 수 있어요.',
          en: 'Use the in-app data export and import feature to move all your records to a new device.',
        },
      },
    ],
  },
];
